import { SimpleForm, TextInput, required, SelectInput, Edit, minValue, maxValue, NumberInput, useDataProvider, useNotify, Toolbar, SaveButton, TopToolbar, TimeInput } from 'react-admin';
import { useEffect, useState } from 'react';
import BackButton from '../../Components/BackButton';


// 自定义整数验证函数
const validateInteger = (value: any) => {
    if (value === null || value === undefined) return;

    // 检查是否为整数
    if (!Number.isInteger(Number(value))) {
        return '必须是整数';
    }

    return undefined; // 验证通过
};

const validateStrategyName = (value: string) => {
    if (!value) return '必填项';

    // 只允许中文、字母、数字、空格和下划线
    if (!/^[\u4e00-\u9fa5a-zA-Z0-9_\s]+$/.test(value)) {
        return '只能包含中文、字母、数字、空格和下划线';
    }

    return undefined;
};


const PostEditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);


const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);


export const strategyEdit = () => {
    const dataProvider = useDataProvider(); // 获取dataProvider
    const [provinceTypeChoices, setProvinceTypeChoices] = useState([]);
    const notify = useNotify();

    useEffect(() => {
        // 异步获取省份列表数据
        const fetchProvinceList = async () => {
            try {
                const { data } = await dataProvider.getProvinceList();

                // 转换为选择框需要的格式：{ id: name, name: name }
                const choices = data.map((province: any) => ({
                    id: province.name,
                    name: province.name
                }));

                setProvinceTypeChoices(choices);
            } catch (error) {
                console.error("获取省份列表失败:", error);
                notify('获取省份列表失败', { type: 'error' });
            }
        };

        fetchProvinceList();
    }, [dataProvider, notify]);


    return (
        <Edit actions={<ActionsToolbar />} mutationMode="pessimistic">
            <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} toolbar={<PostEditToolbar />}>
                <TextInput label="策略名称" source="name" validate={[required(), validateStrategyName]}
                    helperText="只允许中文、字母、数字、空格和下划线" />

                <TimeInput label="开始时间" source="startTime" validate={[required()]} parse={v => {
                    if (v instanceof Date) {
                        return `${v.getHours().toString().padStart(2, '0')}:${v.getMinutes().toString().padStart(2, '0')}`;
                    }
                    return v;
                }} />
                <TimeInput label="结束时间" source="endTime" validate={[required()]} parse={v => {
                    if (v instanceof Date) {
                        return `${v.getHours().toString().padStart(2, '0')}:${v.getMinutes().toString().padStart(2, '0')}`;
                    }
                    return v;
                }} />
                <SelectInput
                    source="region"
                    label="行政区域"
                    choices={provinceTypeChoices}
                />
                <NumberInput
                    label="网速设定"
                    source="networkSpeed"
                    min={1}
                    step={1}
                    validate={[
                        required(),
                        minValue(1, '最小值是1'),
                        maxValue(100, '不能大于100'),
                        validateInteger
                    ]}
                />
                <NumberInput
                    label="CPU占比"
                    source="cpuUsage"
                    min={0}
                    max={100}
                    step={1}
                    validate={[
                        required(),
                        minValue(0, '不能小于0'),
                        maxValue(100, '不能大于100'),
                        validateInteger
                    ]}
                />

                <NumberInput
                    label="RAM占比"
                    source="ramUsage"
                    min={0}
                    max={100}
                    step={1}
                    validate={[
                        required(),
                        minValue(0, '不能小于0'),
                        maxValue(100, '不能大于100'),
                        validateInteger
                    ]}
                />
                <SelectInput
                    source="ipType"
                    label="IP类型"
                    choices={[
                        {
                            id: 'ipv6',
                            name: 'IPv6',
                        },
                        {
                            id: 'ipv4',
                            name: 'IPv4',
                        }
                    ]}
                    validate={[required()]} />
            </SimpleForm>
        </Edit>
    )
};